var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "relative" }, [
    _c("div", {
      staticClass: "ui vertical loader",
      class: { active: _vm.loadForm.waiting },
    }),
    _vm._v(" "),
    _c("table", { staticClass: "chatListTable" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.marunages, function (marunage) {
          return _c(
            "tr",
            { key: marunage.id, staticClass: "chatListTable__row" },
            [
              _c("td", { staticClass: "chatListTable__column" }, [
                _c("a", { attrs: { href: marunage.chat_url } }, [
                  _vm._v("お問合せ番号：" + _vm._s(marunage.code)),
                ]),
                _vm._v(" "),
                _vm.unreadTotalCount(marunage) > 0
                  ? _c("span", { staticClass: "chatListTable__unread" }, [
                      _vm._v(_vm._s(_vm.unreadTotalCount(marunage))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chatListTable__roomMemberContainer" },
                  [
                    _c("span", {
                      staticClass: "chatListTable__roomMember",
                      style: _vm.backgroundImage(
                        _vm.imageUrl("/marunagekun.png")
                      ),
                      attrs: { title: "コンシェルジュ" },
                    }),
                    _vm._v(" "),
                    _vm._l(marunage.marunage_shops, function (each) {
                      return each.chat_url
                        ? _c("span", {
                            key: each.id,
                            staticClass: "chatListTable__roomMember",
                            style: _vm.backgroundImage(
                              each.shop.main_image.urls.small_square
                            ),
                            attrs: { title: each.shop.name },
                          })
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "chatListTable__column" }, [
                _vm._v(_vm._s(_vm._f("formatDatetime")(marunage.created_at))),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "chatListTable__header" }, [
      _c("tr", [
        _c("th", { staticClass: "chatListTable__headerTitleChat" }, [
          _vm._v("チャット"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "chatListTable__headerTitleUpdate" }, [
          _vm._v("お問い合わせ日時"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }